module.exports = __webpack_public_path__ + "static/media/img3-3.b50a6309.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cebolla/nutricheck_foliar/B/img3-3.png
// module id = 1365
// module chunks = 3